import { ApolloError } from "@apollo/client"
import { DeprecatedErrorBlock } from "@hero/krypton"
import React, { ReactNode } from "react"
import { usePayTranslation } from "../translations"
import { GqlHeroError, ValidationGraphQLError } from "./request-error.type"
import { isGqlHeroError, isValidationError } from "./request-error.utils"

/**
 * @deprecated use useHeroQuery instead
 */
export const unwrapGraphQLResponse = <DataType,>(
  response: DataType | GqlHeroError | ValidationGraphQLError | undefined,
):
  | { error: GqlHeroError; data: undefined }
  | { error: ValidationGraphQLError; data: undefined }
  | { error: undefined; data: DataType }
  | { error: undefined; data: undefined } => {
  if (response === undefined) {
    return { error: undefined, data: undefined }
  }
  if (isGqlHeroError(response) || isValidationError(response)) {
    return {
      error: response,
      data: undefined,
    }
  } else if (isValidationError(response)) {
    return {
      error: response,
      data: undefined,
    }
  }
  return { error: undefined, data: response }
}

type Message = string | JSX.Element | ((props: { error: GqlHeroError & { error?: ApolloError } }) => ReactNode)

/**
 * @deprecated use useHeroQuery instead
 */
